<template>
  <el-card class="border-0 rounded-10px">
    <div class="rounded-2xl">
      <div class="w-full bg-white flex py-6 rounded-t-2xl h20">
        <div class="flex items-center w-full w-full">
          <div class="flex items-center w-full cursor-pointer">
            <div class="flex items-center w-1/2">
              <h2 class="font-semibold whitenowrap fsize14 mb-0">Platform</h2>

              <div class="flex w-full flex-wrap ml-4">
                <el-select
                  v-model="selectedPlatform"
                  value-key="page"
                  collapse-tags
                  placeholder="Select"
                  class="z-index-option w-full"
                  @change="changePlatform(selectedPlatform)"
                >
                  <el-option
                    v-for="item in optionStories"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex items-center w-1/2">
              <p class="mb-0 font-semibold mx-4 whitenowrap">Wireframes for</p>
              <el-select
                value-key="name"
                v-model="selectedPage"
                class="selecthomelan w-full"
                @change="selectComponent"
              >
                <el-option
                  v-for="(item, index) in pages"
                  :key="'item' + index"
                  :value="item"
                  :label="item.name"
                >
                </el-option>
                <!-- <option>Homepage</option> -->
              </el-select>
            </div>
          </div>
          <div class="flex items-center">
            <p class="text-xs font-semibold">
              {{
                selectedImage && selectedImage.name ? selectedImage.name : ""
              }}
            </p>
            <div class="h-1.5 w-1.5 rounded-full mx-2 bgc6c7cc"></div>
            <!-- <p class="text-xs font-semibold">{{ selectedStory.ticketID }}</p> -->
            <div class="h-1.5 w-1.5 rounded-full mx-2 bgc6c7cc"></div>
            <!-- <p class="text-xs font-semibold">{{ selectedStory.taskList.name }}</p> -->
            <div class="h-1.5 w-1.5 rounded-full mx-2 bgc6c7cc"></div>
            <p class="text-xs font-semibold">
              {{ selectedStory.suiteOrExtensionName }}
            </p>
          </div>
        </div>
      </div>
      <div class="px-8 py-6 bg-f4f5f6 w-full ht4rem flex">
        <div class="flex justify-between w-full items-center">
          <!-- <div class="flex items-center w-1/3">
            <p class="text-black text-xs font-semibold">
              {{ selectedImage.name }}
            </p>
            <div class="h-1.5 w-1.5 rounded-full mx-4 bgc6c7cc"></div>
            <p class="text-black text-xs font-semibold">Wireframes</p>
          </div> -->
          <div class="flex w-1/2">
            <p class="font-semibold">Dekstop View</p>
            <!-- <b-form-group v-slot="{ ariaDescribedby }" class="cust-rb-wf">
              <b-form-radio
                v-model="selectedPlatform"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="Web"
                class="text-black cust-rb-btn"
                size="sm"
              >
                <div class="flex items-center pt-1">
                  <i class="fas fa-desktop font-semibold text-xs"></i>
                  <p class="text-xs font-semibold ml-2 mb-0 mb-0">
                    Desktop View
                  </p>
                </div></b-form-radio
              >
              <b-form-radio
                v-model="selectedPlatform"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                value="Mobile"
                class="text-black cust-rb-btn ml-6"
              >
                <div class="flex items-center pt-1">
                  <i class="fas fa-mobile-alt font-bold text-xs"></i>
                  <p class="text-xs font-semibold ml-2 mb-0 mb-0">
                    Mobile View
                  </p>
                </div></b-form-radio
              >
            </b-form-group> -->
          </div>
          <div class="w-1/2 flex">
            <div class="flex ml-auto text-black">
              <!-- <div
                @click="changeImage('prev')"
                class="flex items-center mr-4 cursor-pointer"
              >
                <feather-icon icon="ChevronLeftIcon" svgClasses="w-4 h-4" />
                <p class="font-semibold fsize14 ml-2 mb-0">Previous</p>
              </div> -->
              <!-- <div
                @click="changeImage('next')"
                class="flex items-center ml-4 cursor-pointer"
              >
                <p class="font-semibold mr-2 mb-0 fsize14 text-builderprimary">
                  Next
                </p>
                <feather-icon
                  icon="ChevronRightIcon"
                  class="text-builderprimary"
                  svgClasses="w-4 h-4"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="w-full bg-gride-css-wf p-12 rounded-b-2xl border-b-2">
        <!-- WireFrame -->
        <div class="flex text-center">
          <!-- Desktop View -->
          <div
            class="w-70per mx-auto wireframe-scrollbar bg-white"
            v-if="this.selectedPage.type === 'Website'"
          >
            <div v-for="(item, i) in selectedPage.webWireframe" :key="i">
              <img
                :src="
                  showImage(item)
                    ? showImage(item)
                    : showImage('Admin/Assets/Reviews.png')
                "
                alt="WEB"
                class="mx-auto w-full object-contain"
              />
            </div>
            <!-- <img v-else :src="webNoPreview" alt="WEB" /> -->
          </div>

          <!-- Mobile View -->
          <div
            class="w17rem mx-auto bg-white relative"
            v-if="this.selectedPage.type === 'Mobile'"
          >
            <div
              class="h-4 w-4 absolute top-4 left-1/2 right-1/2"
              v-for="(item, i) in selectedPage.mobileWireframe"
              :key="i"
            ></div>
            <img
              :src="
                showImage(item)
                  ? showImage(item)
                  : showImage('Admin/Assets/Reviews-1.png')
              "
              alt="WEB"
              class="mx-auto w-full object-contain"
            />
            <!-- <img v-else :src="mobileNoPreview" alt="Mobile" /> -->
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { mapState } from "vuex";
import Repository from "@/builder/apis/Repository";
export default {
  data() {
    return {
      selectedImage: "",

      webNoPreview: require("../img/no-preview.png"),
      mobileNoPreview: require("../img/no-preview-mobile.png"),
      tasks: [],
      pages: [],
      allImages: [],
      selectedPage: "",
      optionStories: ["Website", "Mobile", "Admin"],
      selectedPlatform: "",
    };
  },

  watch: {
    // selectedPlatform(value) {
    //   console.log(value);
    //   // let platform =
    //   //   newValue === "Web"
    //   //     ? "webWireframe"
    //   //     : newValue === "Mobile"
    //   //     ? "mobileWireframe"
    //   //     : "";
    //   this.getImage();
    // },
    // selectedComponent() {
    //   this.getImage();
    // },
  },

  methods: {
    changePlatform(value) {
      this.getPagesOnMount(value);
    },
    selectComponent() {
      // if (this.$route.name === "stories") {
      // this.$router.push({ name: "stories" }).catch(() => {});
      console.log(this.selectedPage, "pageeeeee");
      this.$store.commit("design/SET_SELECTED_COMPONENT", this.selectedPage);
      // }

      // if (this.$route.name === "wireframe") {
      //   this.$router.push({ name: "wireframe" }).catch(() => {});
      //   this.$store.commit("design/SET_SELECTED_COMPONENT", name);
      // }
      // if (this.$route.name === "testcases") {
      //   this.$router.push({ name: "testcases" }).catch(() => {});
      //   this.$store.commit("design/SET_SELECTED_COMPONENT", name);
      // }
    },
    // getImage() {
    //   this.allImages =
    //     this.selectedPlatform === "Website"
    //       ? this.selectedComponent.webWireframe
    //       : this.selectedComponent.mobileWireframe;
    //   this.selectedImage = this.allImages[0];
    // },

    // changePlatform(platform) {
    //   let allWireframes = this.pages.map((element) => {
    //     let web = element[platform].length
    //       ? element[platform].map((el) => {
    //           return { name: element.name, web: el };
    //         })
    //       : [{ name: element.name, web: "" }];
    //     return web;
    //   });
    //   this.$store.commit(
    //     "design/SET_ALL_IMAGES",
    //     allWireframes.flat().map((el, index) => {
    //       return { name: el.name, wireframe: el.web, index };
    //     })
    //   );
    // },
    backToStories() {
      this.$router.push({ name: "stories" });
    },
    imageUrl(row) {
      return `${this.$imageURL}/${row}`;
      // return `${row}`;
    },

    changeImage(item) {
      let platform =
        this.selectedPlatform === "Website"
          ? "webWireframe"
          : "mobileWireframe";

      console.log(platform, "platform");
      const index = webWireframe.indexOf(platform[0]);
      console.log(index, "index");
      // if (index !== -1) {
      //   this.$store.commit(
      //     "design/SET_WIREFRAME",
      //     item === "next"
      //       ? this.selectedComponent.webWireframe[index + 1]
      //       : this.selectedComponent.webWireframe[index - 1]
      //   );
      // }
      // if (index < 0) {
      //   const index1 = this.allComponents.findIndex(
      //     x => x._id === this.selectedComponent._id
      //   );

      //   this.$store.commit(
      //     "design/SET_SELECTED_COMPONENT",
      //     item === "next"
      //       ? this.allComponents[index1 + 1]
      //       : this.allComponents[index1 - 1]
      //   );

      //   this.$store.commit(
      //     "design/SET_WIREFRAME",
      //     this.selectedComponent.webWireframe[0]
      //   );
      // }
      // this.$store.commit("design/SET_WIREFRAME", item === 'next' ? this.selectedComponent.webWireframe)
    },

    // changeImage(item) {
    //   const index = this.allImages.findIndex((x) => x === this.selectedImage);
    //   console.log(index);
    //   this.selectedImage =
    //     item === "next" ? this.allImages[index + 1] : this.allImages[index - 1];
    // },
    async getTasks() {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        try {
          this.tasks = [];

          const { data } = await Repository.post("/zoho/projects/tasks/", {
            tasklistID: this.selectedSprint._id,
          });

          this.tasks = data.data;

          loader.close();

          resolve(data);
        } catch (error) {
          loader.close();
          reject(error);
        }
      });
    },
    async getPagesOnMount() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch("builder/getPages", {
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            tasklistID: this.selectedSprint._id,
            taskListIdSub: this.selectedSubSprint._id,
            type: this.selectedPlatform,
          });

          this.pages = data.map((x) => ({ ...x, Hrs: 0 }));
          this.selectedPage = data[0];
          // this.selectedPage = data[0];
          // this.selectComponent(data[0]);
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;
      return value ? `${image_base_url}/${value}` : default_image;
    },

    // async getPages() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const { data } = await Repository.post(
    //         "uibuilder/getPages",
    //         {
    //           projectId: this.selectedProject._id,
    //           projectName: this.selectedProject.projectName,
    //           tasklistID: this.selectedSprint._id,
    //         },
    //         {
    //           headers: {
    //             "community-name": this.selectedProject.projectName,
    //           },
    //         }
    //       );
    //       this.pages = data.data.map((x) => ({ ...x, Hrs: 0 }));
    //       resolve(data);
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // },
  },

  computed: {
    ...mapState("design", [
      "selectedStory",
      "selectedSprint",
      "selectedSubSprint",
      "selectedComponent",
      "platform",
    ]),
    ...mapState("user", ["selectedProject"]),
  },

  async mounted() {
    this.selectedPlatform = "Website";
    this.getPagesOnMount();
    // this.getTasks();
    // await this.getPages();
    // this.selectedPlatform = this.platform;
    // await this.getImage();
    // this.selectedImage = this.allImages[0];
    // this.selectedPage = this.selectedComponent;
  },
};
</script>
<style>
.cust-rb-wf {
  margin-bottom: 0rem !important;
  display: flex;
}
.cust-rb-wf > div {
  display: flex;
  align-items: center;
}
.cust-rb-btn > .custom-control-label::before {
  left: -2rem !important;
}
.cust-rb-btn > .custom-control-label::after {
  left: -2rem !important;
}
</style>
